import { render, staticRenderFns } from "./addBrand.vue?vue&type=template&id=50886a00&scoped=true&"
import script from "./addBrand.vue?vue&type=script&lang=js&"
export * from "./addBrand.vue?vue&type=script&lang=js&"
import style0 from "./addBrand.vue?vue&type=style&index=0&id=50886a00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50886a00",
  null
  
)

component.options.__file = "addBrand.vue"
export default component.exports